import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem } from "@my-dld/contexts/PageContext";
import PageContent from "@my-dld/components/PageContent";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { dispatch, navigate } from "@my-dld/utils/StoreUtils";
import { VaultActions } from "../actions";
import { updateVault } from "../VaultContext";
import * as Api from "../api/api";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { exToMessage } from "@eres/ssoapi/api";

interface Props extends RoutedViewProps {

}

interface State {
	vaultRef?: string;
}

export default class Search extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			vaultRef: ""
		};
	}

	componentDidMount() {
		dispatch( VaultActions.RESET_VAULT );
	}

	render() {
		const isValid = this.isValid();
		return <PageContent title={ Strings.dld_vault } hideQLinks={ true }>
			<PageTitle title={ Strings.dld_vault } paths={ [ DashboardBCItem ] }/>

			<div className="row">
				<div className="col-md-12">
					<div className="mandatory-field-info">
						<small>{ Strings.mandatory_label }</small>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-4">
					<TextInputField
						id={ "vaultRef" }
						holder={ this }
						required={ true }
						placeHolder={ Strings.vault_eg_ref }
						label={ Strings.reference_number }/>
					<div className="form-group mt-4">
						<button
							className="btn btn_1 btn_style1"
							disabled={ !isValid }
							onClick={ this.onContinue }
							id="proceedDocumentList">{ Strings.proceed }</button>
						<button
							className="btn btn-grey btn_style1 ms-2 me-2"
							onClick={ this.reset }>{ Strings.reset }</button>
					</div>
				</div>
			</div>
		</PageContent>;
	}

	isValid = () => {
		const { vaultRef } = this.state;
		return !!( vaultRef && vaultRef.match( /^[A-Z]{5}[0-9]{6,}$/ ) );
	};

	onContinue = () => {
		showLoading();
		const query = this.state.vaultRef!;
		Api.searchUserVault( query ).then( r => {
			updateVault( {
				refId: query,
				searchResult: r.data,
			} );
			hideLoading();
			navigate( "/mydld/vault/view" );
		} ).catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				showErrorMessage( message.error );
			} );
		} );
	};
	reset = () => {
		this.setState( {
			vaultRef: "",
		} );
	};

}
